import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {isChunkLoadError, reloadOnceForChunkError} from './app/core/error/chunk-error-handler';

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => {
        // A chunk failing during bootstrap happens before Angular's ErrorHandler
        // is engaged, so recover here too rather than leaving a blank/stuck shell.
        if (isChunkLoadError(err) && reloadOnceForChunkError()) {
            return;
        }
        console.error(err);
    });

